var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.634,
    viewBox: "0 0 24 21.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#888;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2.953)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.5,21.081A4.2,4.2,0,0,1,11.639,16.2h2.948a.6.6,0,0,1,.6.6v3.868a.384.384,0,0,0,.632.292l8.435-7.169a1.558,1.558,0,0,0,0-2.376L15.818,4.243a.384.384,0,0,0-.632.293V8.4a.6.6,0,0,1-.6.6h-3.6A7.792,7.792,0,0,0,3.2,16.8c0,3.417,1.518,5.511,4.655,6.4L7.5,21.081Zm4.138-3.686a3,3,0,0,0-2.956,3.49l.5,3.005a.6.6,0,0,1-.707.686C4.2,23.727,2,21.085,2,16.8A8.991,8.991,0,0,1,10.991,7.8h3V4.535A1.582,1.582,0,0,1,16.6,3.329L25.028,10.5a2.757,2.757,0,0,1,0,4.2L16.6,21.869a1.582,1.582,0,0,1-2.607-1.2v-3.27Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ff47b2ca6130cb6c48bb792d05460fe9.svg";
export { ForwardRef as ReactComponent };